import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import firebase from 'firebase/app'
import { Observable, Subject } from 'rxjs';
import { UserLoginRequest } from 'app/business/user/userloginrequest';
import { GlobalHelper } from 'app/helper/globalhelper';
import { environment } from 'environments/environment';
import { UserLoginResponse } from 'app/business/user/userloginresponse';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionHelperService } from '../util-service/sessionhelper.service';
import { tblUserMaster } from 'app/models/user/tblusermaster';
import { RouteInfo } from 'app/shared/vertical-menu/vertical-menu.metadata';
import { BaseResponse } from 'app/business/common/baseresponse';
import { LookUpItem } from 'app/business/common/lookupitem';

@Injectable()
export class AuthService {
  private user: Observable<firebase.User>;
  private userDetails: firebase.User = null;
  
  // Role change subject for notifying components about role changes
  public roleChangeSubject$ = new Subject<number>();
  public userUpdateSubject$ = new Subject<tblUserMaster>();

  constructor(public _firebaseAuth: AngularFireAuth, public router: Router, private http: HttpClient) {
    this.user = _firebaseAuth.authState;
    this.user.subscribe(
      (user) => {
        if (user) {
          this.userDetails = user;
        }
        else {
          this.userDetails = null;
        }
      }
    );

  }

  async login(loginData: UserLoginRequest): Promise<UserLoginResponse> {
    return await this.http.post(environment.apiUrl + `/Login/UserLogin`, loginData, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as UserLoginResponse;
  }

  async getOtp(loginData: LookUpItem): Promise<BaseResponse> {
    return await this.http.post(environment.apiUrl + `/Login/GetOtp`, loginData, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as BaseResponse;
  }

  async resendOtp(loginData: LookUpItem): Promise<BaseResponse> {
    return await this.http.post(environment.apiUrl + `/Login/ResendOtp`, loginData, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as BaseResponse;
  }

  async forgotPassword(input: LookUpItem): Promise<BaseResponse> {
    return await this.http.post(environment.apiUrl + `/Login/ForgotPassword`, input, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as BaseResponse;
  }

  async verifyForgotPasswordOtp(input: { email: string, otpCode: string, refKey: string }): Promise<BaseResponse> {
    return await this.http.post(environment.apiUrl + `/Login/VerifyForgotPasswordOtp`, input, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as BaseResponse;
  }

  async resetForgotPassword(input: { email: string, resetToken: string, password: string, confirmPassword: string }): Promise<BaseResponse> {
    return await this.http.post(environment.apiUrl + `/Login/ResetForgotPassword`, input, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as BaseResponse;
  }

  async signinViaOTP(otpCode: string, number: string, refKey: string): Promise<UserLoginResponse> {
    return await this.http.get(environment.apiUrl + `/Login/SigninViaOTP/` + otpCode + '/' + number + '/' + refKey, {
      headers: new HttpHeaders({ "No-Auth": "True" })
    })
      .toPromise() as UserLoginResponse;
  }

  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }

  signinUser(email: string, password: string) {
    //your code for checking credentials and getting tokens for for signing in user
    return this._firebaseAuth.signInWithEmailAndPassword(email, password)

  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  isAuthenticated() {
    return !!SessionHelperService.readSessionVariable("userToken");
  }

  public getLoggedInUser(): tblUserMaster {
    const user = JSON.parse(SessionHelperService.readSessionVariable("loginUser"));
    if (user && user.id) {
      return user;
    } else {
      this.logout();
    }
  }

  getVerticalRoutes(): RouteInfo[] {
    const routes: RouteInfo[] = JSON.parse(SessionHelperService.readSessionVariableOnlyKeyEncryption("vroutes")) || [];
    if (routes.length) {
      return routes;
    } else {
      // Don't logout immediately, return empty array for fallback handling
      console.log('No dynamic routes found, will use fallback menu');
      return [];
    }
  }

  setVeticalRoutes(routes: RouteInfo[]): void {
    if (SessionHelperService.readSessionVariableOnlyKeyEncryption("vroutes"))
      SessionHelperService.removeSessionVariable("vroutes");
    SessionHelperService.saveSessionVariableOnlyKeyEncryption("vroutes", JSON.stringify(routes))
  }

  isSuperAdmin(): boolean {
    const user = this.getLoggedInUser();
    return user && user.currentRoleId === 1; // Role.SuperAdmin = 1
  }

  // Notify components about role changes
  notifyRoleChange(newRoleId: number): void {
    this.roleChangeSubject$.next(newRoleId);
  }

}
